// 判断当前环境
const isDev = import.meta.env.DEV

// API 基础地址
// 开发环境优先使用 .env.development，生产环境使用 .env.production
// export const BASE_URL: string = 'http://localhost:8999'
export const BASE_URL: string = 'https://api.oafull.com'

// 客户端（webapp）URL
// export const CLIENT_URL: string = 'http://localhost:3000'
export const CLIENT_URL: string = 'https://www.oafull.com'
